export enum AccessRegistrationGetters {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: any = {}

export default getters
